<script>
import { ref, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth-store";
import ProfileIcon from "@/views/layouts/CustomLayout/profile-icon";

export default {
  components: {
    ProfileIcon,
  },
  data() {
    return {
      isFixed: false,
      isSidebarOpen: false,
    };
  },
  methods: {
    onWindowScroll() {
      // Update isFixed based on the scroll position
      this.isFixed = window.pageYOffset > 50;
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
      document.documentElement.classList.toggle("menu-opened", this.isSidebarOpen);
    },
    closeSidebar() {
      this.isSidebarOpen = false;
      document.documentElement.classList.remove("menu-opened");
    },
  },
  mounted() {
    // Attach scroll event listener
    window.addEventListener("scroll", this.onWindowScroll);
  },
  beforeUnmount() {
    // Clean up the scroll event listener
    window.removeEventListener("scroll", this.onWindowScroll);
    this.closeSidebar();
  },
  setup() {
    const authStore = useAuthStore();
    const isDarkMode = ref(false);
    const route = useRoute();

    const toggleDarkMode = () => {
      if (isDarkMode.value) {
        document.documentElement.classList.remove("dark-mode");
        localStorage.setItem("dark-mode", null);
      } else {
        document.documentElement.classList.add("dark-mode");
        localStorage.setItem("dark-mode", "enabled");
      }
      isDarkMode.value = !isDarkMode.value;
    };

    const initializeDarkMode = () => {
      const darkMode = localStorage.getItem("dark-mode");
      isDarkMode.value = darkMode === "enabled";
    };

    onMounted(() => {
      initializeDarkMode();
      
    });

    watch(isDarkMode, (newVal) => {
      if (newVal) {
        document.documentElement.classList.add("dark-mode");
      } else {
        document.documentElement.classList.remove("dark-mode");
      }
    });

    return {
      isDarkMode,
      toggleDarkMode,
      route, // Pass the route object to the template
      authStore,
    };
  },
  watch: {
    "$route.fullPath"() {
      this.closeSidebar();
    },
  },
};
</script>

<template>
  <!-- Header Topbar-->
  <!-- <div
    class="header-topbar text-center"
    v-if="
      route.path === '/home/index-2' ||
      route.path.startsWith('/course/') ||
      route.path.startsWith('/pages/') ||
      route.path.startsWith('/courses/') ||
      route.path.startsWith('/category/') ||
      route.path.startsWith('/details/') ||
      route.path.startsWith('/instructor/') ||
      route.path.startsWith('/students/') ||
      route.path.startsWith('/principal/') ||
      route.path.startsWith('/blog-layouts/') ||
      route.path.startsWith('/blogs/')
    "
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div
            class="d-flex align-items-center justify-content-center justify-content-lg-start"
          >
            <p class="d-flex align-items-center fw-medium fs-14 mb-2 me-3">
              <i class="isax isax-location5 me-2"></i>1442 Crosswind Drive
              Madisonville
            </p>
            <p class="d-flex align-items-center fw-medium fs-14 mb-2">
              <i class="isax isax-call-calling5 me-2"></i>+1 45887 77874
            </p>
          </div>
        </div>
        <div class="col-lg-6">
          <div
            class="d-flex align-items-center justify-content-center justify-content-lg-end"
          >
            <div class="dropdown flag-dropdown mb-2 me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src="@/assets/img/flags/us-flag.svg"
                  class="me-2"
                  alt="flag"
                />ENG
              </a>
              <ul class="dropdown-menu p-2 mt-2">
                <li>
                  <a
                    class="dropdown-item rounded d-flex align-items-center"
                    href="javascript:void(0);"
                  >
                    <img
                      src="@/assets/img/flags/us-flag.svg"
                      class="me-2"
                      alt="flag"
                    />ENG
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item rounded d-flex align-items-center"
                    href="javascript:void(0);"
                  >
                    <img
                      src="@/assets/img/flags/arab-flag.svg"
                      class="me-2"
                      alt="flag"
                    />ARA
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item rounded d-flex align-items-center"
                    href="javascript:void(0);"
                  >
                    <img
                      src="@/assets/img/flags/france-flag.svg"
                      class="me-2"
                      alt="flag"
                    />FRE
                  </a>
                </li>
              </ul>
            </div>
            <div class="dropdown mb-2 me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                USD
              </a>
              <ul class="dropdown-menu p-2 mt-2">
                <li>
                  <a class="dropdown-item rounded" href="javascript:void(0);"
                    >USD</a
                  >
                </li>
                <li>
                  <a class="dropdown-item rounded" href="javascript:void(0);"
                    >YEN</a
                  >
                </li>
                <li>
                  <a class="dropdown-item rounded" href="javascript:void(0);"
                    >EURO</a
                  >
                </li>
              </ul>
            </div>
            <ul class="social-icon d-flex align-items-center mb-2">
              <li class="me-2">
                <a href="javascript:void(0);"
                  ><i class="fa-brands fa-facebook-f"></i
                ></a>
              </li>
              <li class="me-2">
                <a href="javascript:void(0);"
                  ><i class="fa-brands fa-instagram"></i
                ></a>
              </li>
              <li class="me-2">
                <a href="javascript:void(0);"
                  ><i class="fa-brands fa-x-twitter"></i
                ></a>
              </li>
              <li class="me-2">
                <a href="javascript:void(0);"
                  ><i class="fa-brands fa-youtube"></i
                ></a>
              </li>
              <li>
                <a href="javascript:void(0);"
                  ><i class="fa-brands fa-linkedin"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- /Header Topbar-->

  <!-- Header -->
  <header
    class=""
    :class="{
      'header-one': route.path === '/home',
      'header-two': route.path === '/home/index-2',
      'header-three position-fixed': route.path === '/home/index-3',
      'header-four': route.path === '/home/index-4',
      'header-two header-five position-fixed': route.path === '/home',
      'header-three': route.path === '/home/index-6',
      fixed: isFixed,
    }"
  >
    <div class="container">
      <div class="header-nav">
        <div class="navbar-header">
          <div class="navbar-logo my-lg-4 my-0">
            <router-link
              v-if="
                [
                  '/home/index-2',
                  '/home/index-3',
                  '/home/index-4',
                  '/home',
                  '/home/index-6',
                ].includes(route.path) ||
                route.path.startsWith('/course') ||
                route.path.startsWith('/pages') ||
                route.path.startsWith('/courses') ||
                route.path.startsWith('/category') ||
                route.path.startsWith('/details') ||
                route.path.startsWith('/instructor') ||
                route.path.startsWith('/students') ||
                route.path.startsWith('/principal')
              "
              class="logo-white header-logo"
              to="/"
            >
              <img src="@/assets/logo/sapta.png" class="logo header-logo-img" alt="Sapta LMS" />
            </router-link>
            <router-link class="logo-dark header-logo" to="/home">
              <img src="@/assets/logo/sapta.png" class="logo header-logo-img" alt="Sapta LMS" />
            </router-link>
          </div>
        </div>

        <header-menu id="mobile-main-menu"></header-menu>
        <!-- nav menu -->
        <div
          v-if="
            !['/home/index-3', '/home/index-4'].includes(route.path) &&
            !route.path.startsWith('/course/') &&
            !route.path.startsWith('/pages/') &&
            !route.path.startsWith('/courses/') &&
            !route.path.startsWith('/category/') &&
            !route.path.startsWith('/details/') &&
            !route.path.startsWith('/instructor/') &&
            !route.path.startsWith('/students/') &&
            !route.path.startsWith('/pages/')
          "
        >
          <div class="header-btn d-flex align-items-center">
            <!-- <div class="dropdown flag-dropdown icon-btn me-2">
                            <a href="javascript:void(0);" class="d-inline-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src="@/assets/img/flags/us-flag.svg" alt="flag">
                            </a>
                            <ul class="dropdown-menu p-2 mt-2">
                                <li>
                                    <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                                        <img src="@/assets/img/flags/us-flag.svg" class="me-2" alt="flag">ENG
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                                        <img src="@/assets/img/flags/arab-flag.svg" class="me-2" alt="flag">ARA
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                                        <img src="@/assets/img/flags/france-flag.svg" class="me-2" alt="flag">FRE
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="dropdown icon-btn me-2">
                            <a href="javascript:void(0);" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="isax isax-dollar-circle4"></i>
                            </a>
                            <ul class="dropdown-menu p-2 mt-2">
                                <li><a class="dropdown-item rounded" href="javascript:void(0);">USD</a></li>
                                <li><a class="dropdown-item rounded" href="javascript:void(0);">YEN</a></li>
                                <li><a class="dropdown-item rounded" href="javascript:void(0);">EURO</a></li>
                            </ul>
                        </div> -->
            <div class="icon-btn me-2">
              <a
                href="javascript:void(0);"
                id="dark-mode-toggle"
                @click="toggleDarkMode"
                :class="{ 'theme-toggle activate': true, activate: isDarkMode }"
              >
                <i
                  class="isax"
                  :class="[isDarkMode ? 'isax-sun-15' : 'isax-moon']"
                ></i>
              </a>
            </div>
            <div
              v-if="
                route.path !== '/home/index-2' && route.path !== '/home/index-5'
              "
            >
              <router-link
                v-if="!authStore.currentUser"
                to="/login"
                class="btn btn-primary d-inline-flex align-items-center me-2"
              >
                Sign In
              </router-link>
              <ProfileIcon v-if="authStore.currentUser"/>
            </div>
            <div
              v-if="
                route.path === '/home/index-2' || route.path === '/home/index-5'
              "
            >
              <router-link
                to="/login"
                class="btn btn-light d-inline-flex align-items-center me-2"
              >
                <i class="isax isax-lock-circle me-2"></i>Sign In
              </router-link>
            </div>
          </div>
        </div>
        <!-- sama sekali tidak di pakai -->
        <div
          v-if="['/home/index-3', '/home/index-4'].includes(route.path)"
          class="header-btn d-flex align-items-center"
        >
          <div class="icon-btn me-2">
            <a
              href="javascript:void(0);"
              id="dark-mode-toggle"
              @click="toggleDarkMode"
              :class="{ 'theme-toggle activate': true, activate: isDarkMode }"
            >
              <i
                class="isax"
                :class="[isDarkMode ? 'isax-sun-15' : 'isax-moon']"
              ></i>
            </a>
          </div>

          <div class="dropdown flag-dropdown me-3">
            <a
              href="javascript:void(0);"
              class="dropdown-toggle d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                src="@/assets/img/flags/us-flag.svg"
                class="me-2"
                alt="flag"
              />ENG
            </a>
            <ul class="dropdown-menu p-2 mt-2">
              <li>
                <a
                  class="dropdown-item rounded d-flex align-items-center"
                  href="javascript:void(0);"
                >
                  <img
                    src="@/assets/img/flags/us-flag.svg"
                    class="me-2"
                    alt="flag"
                  />ENG
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item rounded d-flex align-items-center"
                  href="javascript:void(0);"
                >
                  <img
                    src="@/assets/img/flags/arab-flag.svg"
                    class="me-2"
                    alt="flag"
                  />ARA
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item rounded d-flex align-items-center"
                  href="javascript:void(0);"
                >
                  <img
                    src="@/assets/img/flags/france-flag.svg"
                    class="me-2"
                    alt="flag"
                  />FRE
                </a>
              </li>
            </ul>
          </div>
          <div class="dropdown me-3">
            <a
              href="javascript:void(0);"
              class="dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              USD
            </a>
            <ul class="dropdown-menu p-2 mt-2" style="">
              <li>
                <a class="dropdown-item rounded" href="javascript:void(0);"
                  >USD</a
                >
              </li>
              <li>
                <a class="dropdown-item rounded" href="javascript:void(0);"
                  >YEN</a
                >
              </li>
              <li>
                <a class="dropdown-item rounded" href="javascript:void(0);"
                  >EURO</a
                >
              </li>
            </ul>
          </div>
          <router-link
            to="/login"
            class="btn btn-primary d-inline-flex align-items-center me-2"
            >Sign In</router-link
          >
          <!-- <router-link to="/register" class="btn btn-secondary me-0">Register</router-link> -->
        </div>
        <!-- Content -->
        <div
          class="header-btn d-flex align-items-center"
          v-if="
            route.path.startsWith('/course/') ||
            route.path.startsWith('/pages/') ||
            route.path.startsWith('/courses/') ||
            route.path.startsWith('/category/') ||
            route.path.startsWith('/details/')
          "
        >
          <div class="icon-btn me-2">
            <a
              href="javascript:void(0);"
              id="dark-mode-toggle"
              @click="toggleDarkMode"
              :class="{ 'theme-toggle activate': true, activate: isDarkMode }"
            >
              <i
                class="isax"
                :class="[isDarkMode ? 'isax-sun-15' : 'isax-moon']"
              ></i>
            </a>
          </div>
          <!-- <div class="icon-btn me-3">
                        <router-link to="/courses/cart" class="position-relative">
                            <i class="isax isax-shopping-cart5"></i>
                            <span class="count-icon bg-success p-1 rounded-pill text-white fs-10 fw-bold">1</span>
                        </router-link>
                    </div> -->
          <router-link
            to="/login"
            class="btn btn-light d-inline-flex align-items-center me-2"
            v-if="!authStore.currentUser"
          >
            <i class="isax isax-lock-circle me-2"></i>Sign In
          </router-link>
          <!-- <router-link to="/register" class="btn btn-secondary me-0">
                        <i class="isax isax-user-edit me-2"></i>Register
                    </router-link> -->
          <ProfileIcon v-if="authStore.currentUser"/>
        </div>

        <div
          class="header-btn d-flex align-items-center"
          v-if="route.path.startsWith('/instructor/')"
        >
          <div class="icon-btn me-2">
            <a
              href="javascript:void(0);"
              id="dark-mode-toggle"
              @click="toggleDarkMode"
              :class="{ 'theme-toggle activate': true, activate: isDarkMode }"
            >
              <i
                class="isax"
                :class="[isDarkMode ? 'isax-sun-15' : 'isax-moon']"
              ></i>
            </a>
          </div>
          <!-- <div class="icon-btn me-3">
                        <router-link to="/courses/cart" class="position-relative">
                            <i class="isax isax-shopping-cart5"></i>
                            <span class="count-icon bg-success p-1 rounded-pill text-white fs-10 fw-bold">1</span>
                        </router-link>
                    </div> -->
          <ProfileIcon v-if="authStore.currentUser"/>
        </div>
        <div
          class="header-btn d-flex align-items-center"
          v-if="route.path.startsWith('/students/')"
        >
          <div class="icon-btn me-2">
            <a
              href="javascript:void(0);"
              id="dark-mode-toggle"
              @click="toggleDarkMode"
              :class="{ 'theme-toggle activate': true, activate: isDarkMode }"
            >
              <i
                class="isax"
                :class="[isDarkMode ? 'isax-sun-15' : 'isax-moon']"
              ></i>
            </a>
          </div>
          <!-- <div class="icon-btn me-3">
                        <router-link to="/courses/cart" class="position-relative">
                            <i class="isax isax-shopping-cart5"></i>
                            <span class="count-icon bg-success p-1 rounded-pill text-white fs-10 fw-bold">1</span>
                        </router-link>
                    </div> -->
          <ProfileIcon v-if="authStore.currentUser"/>
        </div>

        <a
          id="mobile_btn"
          href="javascript:void(0);"
          role="button"
          aria-label="Open menu"
          :aria-expanded="isSidebarOpen ? 'true' : 'false'"
          aria-controls="mobile-main-menu"
          @click="toggleSidebar"
        >
          <span class="bar-icon">
            <i class="isax isax-menu" aria-hidden="true"></i>
          </span>
        </a>
      </div>
    </div>
    <div
      class="sidebar-overlay"
      :class="{ opened: isSidebarOpen }"
      @click="closeSidebar"
    ></div>
  </header>
  <!-- /Header -->
</template>

<style scoped>
.header-logo-img {
  max-width: 140px;
  width: auto;
  height: auto;
  max-height: 40px;
  object-fit: contain;
}
@media (max-width: 991.98px) {
  .header-logo-img {
    max-width: 110px;
    max-height: 36px;
  }
}
@media (max-width: 575.98px) {
  .header-logo-img {
    max-width: 96px;
    max-height: 32px;
  }
}
</style>
